import React, { Component } from 'react';
import axios from 'axios';
import {API_URL} from '../../../constants';
import Error from '../../../components/Error/error';
// import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import Moment from 'moment';
import cookie from 'react-cookies';
import {approveRole} from '../../../functions';
import ResourcePagination from '../../Elements/Pagination/resourcepagination';
import $ from "jquery";
import { Pagination } from '../../Elements/Pagination/tablePagination';


function Estado(key)
{
    switch(key)
    {
        case "B": return <span className="label label-primary">BORRADOR</span>;
        case "R": return <span className="label label-default">PRE-APROBADO</span>;
        case "A": return <span className="label label-info" style={{background: "#44AA44"}}>APROBADO</span>;
        default: break;
    }
}


export default class Boletin extends Component {

    constructor (props){
        super(props);
        this.state = {
            resource: [],
            response: [],
            error: [],
            security: cookie.load('user'),
            roles: [],
            pagina: 1
        }
    }

    

    render() {

        Moment.updateLocale('en', {
            months : [
                "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio",
                "Agosto", "Setiembre", "Octubre", "Noviembre", "Diciembre"
            ]
        });

        Moment.updateLocale('en', {
            weekdays : [
                "Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"
            ]
        });

        return (
            (this.state.response.statusCode === 200) ? 
            (
                <div id="detailBody" className="Site-content" >
                    <div className="loader"></div>
                    <div hidden={true} id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <div id="Body" className="body-container container-fluid">
                            <div className="content-option" >
                                <div className="row recursos__search section__margin-bottom">
                                    <div className="col-sm-8">
                                        <div className="ibox-content">
                                                <div className="search-form">
                                                        <div className="input-group">
                                                            <i className="recursos__search-icon fas fa-search"></i>
                                                            <input type="text" placeholder="NOMBRE DEL BOLETIN" name="search" className="recursos__search-form-control form-control input-lg" />
                                                            <div className="input-group-btn">
                                                                <button className="btn btn-primary btn-primary__submit" type="submit">
                                                                    <i className="fas fa-search" style={{ marginRight: "8px" }} />
                                                                    BUSCAR
                                                                </button>
                                                            </div>
                                                            &nbsp;&nbsp;
                                                            <div className="input-group-btn">
                                                                <button className="btn btn-success btn-primary__submit" onClick={() => this.addResource()} type="submit">
                                                                    <i className="fas fa-save" style={{ marginRight: "8px" }} />
                                                                    NUEVO
                                                                </button>
                                                            </div>
                                                        </div>
                                                </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-12">
                                        <div className="recursos__wrapper-table">
                                            <table id="recursos__table" className="table table-striped table-bordered" >
                                                <thead>
                                                    <tr>
                                                        <th className="table-bordered-radius--left">CÓDIGO</th>
                                                        <th>TÍTULO DEL BOLETIN</th>
                                                        <th>DESCRIPCION</th>
                                                        <th>SECTOR</th>
                                                        <th>USUARIO</th>
                                                        <th>FECHA</th>
                                                        <th className="text-center">ESTADO</th>
                                                        <th className="table-bordered-radius--right text-center">ACCIÓN</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                {this.state.resource.map((resource) => (
                                                    <tr key={resource.nBoletinCodigo}>
                                                        <td>{resource.nBoletinCodigo}</td>
                                                        <td>{resource.sTitulo}</td>
                                                        <td>{resource.sDescripcion}</td>
                                                        <td>{resource.sSector}</td>
                                                        <td>{resource.sUsuario}</td>
                                                        <td>{Moment(resource.dFechaCreacion).format('dddd DD, MMMM YYYY')}</td>
                                                        <td className="text-center">
                                                            {Estado(resource.cEstado)}
                                                        </td>
                                                        {/* <td className="text-center">
                                                            {(resource.bActivo?<span className="label label-info">ACTIVO</span>:<span className="label label-warning">INACTIVO</span>)}
                                                        </td> */}
                                                        <td className="recursos__table-action-option">
                                                            <button className="btn btn-primary btn-primary__tool" onClick={() => this.editResource(resource.nBoletinCodigo)} type="button"><i className="fas fa-pen fa-sm"></i></button>
                                                        </td>
                                                    </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                            
                                            {this.state.resource.length > 0 &&
                                                <div>
                                                    <Pagination
                                                        data={this.state.resource}
                                                        pagina={this.state.pagina}
                                                        changePage={(page) => this.getDataByPagination(page)}
                                                    />

                                                </div>
                                            }

                                            {/* this.state.resource.length > 0 &&
                                                <ResourcePagination
                                                    resource={this.state.resource}
                                                    state={this.state}
                                                    getDataByPagination={this.getDataByPagination}
                                                    setState={(data) => this.setState(data)}
                                                />
                                            */}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            )
            :
            (
                <Error StatusCode={this.state.response.StatusCode} StatusMessage={this.state.response.StatusMessage}></Error>
            )
        );
    }

    editResource(id){
        this.props.history.push({
            pathname: '/edit-boletin/' + id,
            state: { key: id }
          });
    }

    addResource(){
        this.props.history.push({
            pathname: '/add-boletin/',
            state: { key: 0}
          });
    }

    // Function to handle ResourcePagination
    getDataByPagination(page){
        var roles = this.state.security.cRolesxUsuario.filter(option=> { return option.cRoles.nTipSistema==="0"; });
        var flag = approveRole(roles);
        //var estados= (flag?('A,R'):('B'));
        var usuario = 0;//(flag?(0):(this.state.security.nUsuCodigo));
        const url = `${API_URL}BulletinUX/${page}/X/${usuario}/0`;
        axios.get(url).then(response => response.data)
        .then((data) => {
            this.setState({ 
                resource: data.result, 
                response: data, 
                error: data.Error, 
                page: page 
            });
        })
        .catch(error => {
        });
    }

    componentDidMount(){

        //document.getElementById('containerPanel').style='display:none';
        $(".divContenidoPanelNav").animate({"left": "-510px"});
        
        var roles = this.state.security.cRolesxUsuario.filter(option=> { return option.cRoles.nTipSistema==="0"; });
        var flag = approveRole(roles);
        var usuario = 0; //(flag?(0):(this.state.security.nUsuCodigo));
        const url = `${API_URL}BulletinUX/1/X/${usuario}/0`;
        axios.get(url).then(response => response.data)
        .then((data) => {
            console.log(data);
            this.setState({ 
                resource:   data.result, 
                response:   data, 
                error:      data.Error, 
                roles:      roles,
                page:       1 
            });
            
            if(document.querySelector('.loader')){
                document.querySelector('.loader').classList.add('loader--hide');
            }
            document.getElementById('content-wrapper').removeAttribute("hidden");
        })
        .catch(error => {
            const loader = document.querySelector('.loader')
            
            if(loader){
                loader.classList.add('loader--hide')
            }

            toast.error('Error de comunicación');
        });
    }
}
